const LOCALE = "pt-BR";
const CURRENCY_OPTIONS = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
};

const formatCurrency = (value) =>
  Number(value).toLocaleString(LOCALE, CURRENCY_OPTIONS);

const formatCurrencyValue = (value) => `R$ ${formatCurrency(value)}`;

const createAnnualBracket = ({ upTo, rate, deduction, min }) => ({
  min,
  upTo,
  rate,
  deduction,
  rateLabel: rate === 0 ? "-" : `${String(rate).replace(".", ",")}%`,
  deductionLabel: rate === 0 ? "-" : formatCurrency(deduction),
  baseLabel:
    min === 0
      ? `Até ${formatCurrencyValue(upTo)}`
      : upTo
      ? `De ${formatCurrencyValue(min)} até ${formatCurrencyValue(upTo)}`
      : `Acima de ${formatCurrencyValue(min)}`,
});

export const IRPF_CONFIG = {
  declarationYear: 2026,
  calendarYear: 2025,
  declarationLabel: "Declaração IR 2026",
  declarationPath: "/declaracao2026",
  links: {
    whoMustDeclare:
      "https://www.gov.br/receitafederal/pt-br/assuntos/meu-imposto-de-renda/quem",
    annualTables:
      "https://www.gov.br/receitafederal/pt-br/assuntos/meu-imposto-de-renda/tabelas/2025",
    refundLots:
      "https://www.gov.br/receitafederal/pt-br/assuntos/meu-imposto-de-renda/restituicao/lotes/2026",
    refundLotsOverview:
      "https://www.gov.br/receitafederal/pt-br/assuntos/meu-imposto-de-renda/restituicao/lotes",
    instructionNorm:
      "https://normasinternet2.receita.fazenda.gov.br/#/consulta/externa/149930",
  },
  obligationLimits: {
    taxableIncome: 35584.0,
    exemptIncome: 200000.0,
    ruralRevenue: 177920.0,
    assets: 800000.0,
    stockOperations: 40000.0,
  },
  deductions: {
    simplifiedRate: 0.2,
    simplifiedDeductionLimit: 16754.34,
    dependentDeduction: 2275.08,
    educationLimitPerPerson: 3561.5,
  },
  annualBrackets: [
    createAnnualBracket({
      min: 0,
      upTo: 28467.2,
      rate: 0,
      deduction: 0,
    }),
    createAnnualBracket({
      min: 28467.21,
      upTo: 33919.8,
      rate: 7.5,
      deduction: 2135.04,
    }),
    createAnnualBracket({
      min: 33919.81,
      upTo: 45012.6,
      rate: 15,
      deduction: 4679.03,
    }),
    createAnnualBracket({
      min: 45012.61,
      upTo: 55976.16,
      rate: 22.5,
      deduction: 8054.97,
    }),
    createAnnualBracket({
      min: 55976.16,
      upTo: null,
      rate: 27.5,
      deduction: 10853.78,
    }),
  ],
  refundSchedule: {
    referenceYear: 2026,
    lastUpdated: "16/03/2026",
    lots: ["29/05/2026", "30/06/2026", "31/07/2026", "28/08/2026"],
    hasPendingLots: true,
  },
};

export { formatCurrency, formatCurrencyValue };
